module.exports = __webpack_public_path__ + "static/media/shopimg_blue.cc3128aa.svg";